/* eslint-disable import/prefer-default-export */
import { asyncActionType } from 'util/methods';

export const AdminTestPlanTypes = {
  GET_ADMIN_TEST_PLAN_LIST: asyncActionType('GET_ADMIN_TEST_PLAN_LIST'),
  GET_ADMIN_ARCHIVED_TEST_PLAN_LIST: asyncActionType('GET_ADMIN_ARCHIVED_TEST_PLAN_LIST'),
  GET_ADMIN_DRAFT_TEST_PLAN_LIST: asyncActionType('GET_ADMIN_DRAFT_TEST_PLAN_LIST'),
  GET_ADMIN_TEST_PLAN_TAGS: asyncActionType('GET_ADMIN_TEST_PLAN_TAGS'),

  GET_ADMIN_TEST_PLAN_DETAIL: asyncActionType('GET_ADMIN_TEST_PLAN_DETAIL'),
  CREATE_ADMIN_TEST_PLAN_DETAIL: asyncActionType('CREATE_ADMIN_TEST_PLAN_DETAIL'),
  UPDATE_ADMIN_TEST_PLAN_DETAIL: asyncActionType('UPDATE_ADMIN_TEST_PLAN_DETAIL'),
  DELETE_ADMIN_TEST_PLAN_DETAIL: asyncActionType('DELETE_ADMIN_TEST_PLAN_DETAIL'),
  CHECK_TEST_PLAN_EXISTED: asyncActionType('CHECK_TEST_PLAN_EXISTED'),
  ARCHIVE_TEST_PLAN: asyncActionType('ARCHIVE_TEST_PLAN'),
  EDIT_TEST_PLAN_TAGS: asyncActionType('EDIT_TEST_PLAN_TAGS'),
};
